<template>
  <div class="px-3" style="background-color: rgb(244, 245, 247)">
    <div v-if="user.level == 'Admin'">
      <AdminInterface/>
    </div>
    <div v-else>
      <UserInterface/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import AdminInterface from "../components/AdminInterface.vue";
import UserInterface from "../components/UserInterface.vue";

export default {
  name: "Proposals",
  components: {
    AdminInterface,
    UserInterface,

  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState([
      "user",
    ]),
  }
};
</script>

<style scoped>
i.fas.fa-plus {
  color: #ffffff;
  background-color: #007bff;
  height: 50px;
  width: 50px;
  line-height: 50px;
  border-radius: 35px;
}

i.fas.fa-plus:hover {
  color: #ffffff;
  background-color: #ec9a3c;
  border-radius: 35px;
}

.list-group-wrapper {
  position: relative;
}

.list-group {
  overflow: auto;
  height: 50vh;
  border: 2px solid #dce4ec;
  border-radius: 5px;
}
.list-group-item {
  margin-top: 1px;
  border-left: none;
  border-right: none;
  border-top: none;
  border-bottom: 2px solid #dce4ec;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.exp {
  position: relative;
  bottom: 7px;
}
</style>
